import React, { useContext } from 'react';
import ButtonGreen from './ButtonGreen';
import GradientBorder from '../../ui/GradientBorder';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import yellowMetaIcon from '../../assets/greenpill/yellowMetaIcon.png';
import { getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import { toast } from 'sonner';
import { AuthContext } from '../../contexts/AuthContext';
import { updateWallet } from '../../apis/geenpills/updateWallet';
import { useWallet } from '@solana/wallet-adapter-react';
import ButtonNew from '../../ui/ButtonNew';

// const metaConnection = async (linkedWallet) => {
//     const metaMaskProvider = getMetaMaskProvider();
//     if (!metaMaskProvider) {
//         const installUrl = 'https://metamask.io/download.html';
//         toast.info('Opening MetaMask installation page in a new tab...');
//         window.open(installUrl, '_blank'); // Open the URL in a new tab
//         // toast.error('MetaMask is not installed or unavailable');
//         return;
//     }
//     const accounts = await metaMaskProvider.request({
//         method: 'eth_requestAccounts',
//     });
//     console.log(accounts);
//     if (!accounts || accounts.length === 0) {
//         toast.error('Failed to connect wallet');
//         return;
//     }

//     if (accounts[0]?.toLowerCase() === linkedWallet?.toLowerCase()) {
//         toast?.error('This wallet is already connected to your profile.You can mint now');
//         return;
//     }

//     console.log('update the wallet here and then navigate the user back to minting after updating the state');
// };
// const phantomConnection = async (linkedWallet, wallet) => {
//     try {
//         const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
//         if (!phantom || !phantom.adapter) {
//             toast.error('Phantom wallet not found');
//             return;
//         }

//         if (phantom.adapter?.name !== 'Phantom') {
//             await wallet.select(phantom.adapter.name);
//         }

//         if (!phantom.adapter.connected) {
//             await phantom.adapter.connect();
//         }

//         const publicKey = phantom.adapter.publicKey;
//         if (!publicKey) {
//             toast.error('Failed to get Phantom wallet address');
//             return;
//         }

//         const newWallet = publicKey.toBase58()?.toLowerCase();
//         const existingWallet = linkedWallet?.toLowerCase();

//         if (newWallet === existingWallet) {
//             toast.error(
//                 'This wallet is already connected. To switch wallets, please disconnect from Phantom first and choose the account to which you want to connect.'
//             );
//             return;
//         }

//         return publicKey.toBase58();
//     } catch (error) {
//         console.error('Phantom Wallet Error:', error);
//         toast.error('Error connecting to Phantom wallet');
//     }
// };

const phantomConnection = async (linkedWallet, wallet) => {
    try {
        const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
        console.log(phantom.adapter, phantom.adapter.connected, phantom.adapter.disconnect || 'hima');
        if (!phantom || !phantom.adapter) {
            toast.error('Phantom wallet not found');
            return;
        }

        // Select Phantom wallet if not already selected
        if (phantom.adapter?.name !== 'Phantom') {
            await wallet.select(phantom.adapter.name);
        }

        // Disconnect if already connected
        if (phantom.adapter.connected) {
            console.log('jhd');
            await phantom.adapter.disconnect();
        }

        // Now connect to Phantom
        await phantom.adapter.connect();

        const publicKey = phantom.adapter.publicKey;
        if (!publicKey) {
            toast.error('Failed to get Phantom wallet address');
            return;
        }

        const newWallet = publicKey.toBase58()?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (newWallet === existingWallet) {
            toast.error(
                'This wallet is already connected. To switch wallets, please disconnect from Phantom first and choose the account to which you want to connect.'
            );
            return;
        }

        return publicKey.toBase58();
    } catch (error) {
        console.error('Phantom Wallet Error:', error);
        toast.error('Error connecting to Phantom wallet');
    }
};

const metaConnection = async (linkedWallet) => {
    const metaMaskProvider = getMetaMaskProvider();

    if (!metaMaskProvider) {
        const installUrl = 'https://metamask.io/download.html';
        toast.info('Opening MetaMask installation page in a new tab...');
        window.open(installUrl, '_blank');
        return;
    }

    try {
        // Always prompt MetaMask popup
        const accounts = await metaMaskProvider.request({
            method: 'wallet_requestPermissions',
            params: [{ eth_accounts: {} }],
        });

        // Now explicitly request selected accounts again
        const selectedAccounts = await metaMaskProvider.request({
            method: 'eth_requestAccounts',
        });

        if (!selectedAccounts || selectedAccounts.length === 0) {
            toast.error('No wallet selected. Connection cancelled.');
            return;
        }

        const newWallet = selectedAccounts[0]?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (newWallet === existingWallet) {
            toast.error(
                'This wallet is already connected. To switch wallets, please disconnect from MetaMask first and choose the account to which you want to connect.'
            );
            return;
        }

        return newWallet;
    } catch (error) {
        console.error('MetaMask connection error:', error);
        toast.error('Failed to connect MetaMask wallet.');
    }
};

const ChangeWalletWhite = ({ close, handleChangeWalletAddress, type, linkedWallet, from }) => {
    const { dispatch } = useContext(AuthContext);
    const wallet = useWallet();

    console.log(type, from, linkedWallet, 'working on phantom');
    const changeHandler = async () => {
        if (type === 'phantom') {
            const newWallet = await phantomConnection(linkedWallet, wallet);
            if (newWallet && newWallet !== linkedWallet) {
                const response = await updateWallet(undefined, newWallet);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                }

                if (response?.walletAddress) {
                    toast?.success('Wallet changed successfully');
                    dispatch({ type: 'changeWalletSolana', payload: newWallet });
                    // or 'phantom' depending on type
                }
            }
        }
        if (type === 'metamask') {
            const newWallet = await metaConnection(linkedWallet);
            if (newWallet && newWallet !== linkedWallet) {
                const response = await updateWallet(newWallet, undefined);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                }

                if (response?.evmAddress) {
                    toast?.success('Wallet changed successfully');
                    dispatch({ type: 'changeWalletEVM', payload: newWallet });
                    // or 'phantom' depending on type
                }
            }
        }

        handleChangeWalletAddress('', '');
    };
    return (
        <div>
            <div className="flex items-center justify-between">
                <ButtonNew
                    onClick={() => {
                        handleChangeWalletAddress('', '');
                    }}
                    variant="closeNeutral"
                    size="xs"
                    shape="oval"
                    className=" !p-0"
                    fixedMinWidth
                    minWidthClass="min-w-[2.5rem]"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="14.5713" cy="15.4287" r="14.5713" fill="none" />
                        <path
                            d="M17.6378 10.3794L16.4846 9.29346L9.96875 15.4287L16.4846 21.564L17.6378 20.4781L12.2753 15.4287L17.6378 10.3794Z"
                            fill="#B2B2B2"
                        />
                    </svg>
                </ButtonNew>

                <h1
                    className="text-2xl font-semibold text-textPrimary "
                    style={{
                        textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                    }}
                >
                    <>
                        Are you sure you want to
                        <br />
                        change the linked wallet?
                    </>
                </h1>
                <ButtonNew
                    onClick={() => {
                        close();
                    }}
                    variant="closeNeutral"
                    size="xs"
                    shape="oval"
                    className=" !p-0"
                    fixedMinWidth
                    minWidthClass="min-w-[2.5rem]"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="15" cy="15" r="15" fill="none" />
                        <path d="M20.5918 10L10.5914 20.0004" stroke="#B2B2B2" strokeWidth="2" strokeLinecap="round" />
                        <path d="M20 20L9.99964 9.99964" stroke="#B2B2B2" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </ButtonNew>

            </div>
            <p className="text-textSecondary mt-3 mb-6 text-center ">
                Update your wallet address below or go back to use existing wallet
            </p>

            <div className="flex items-center justify-center">
                <button
                    onClick={changeHandler}
                    type="button"
                    className={` px-4 py-2 flex items-center gap-2 rounded-sm text-white  ${type === 'metamask' ? 'bg-metamask-gradient' : 'bg-phantom-gradient'
                        }  justify-between`}
                >
                    <img
                        className="w-7 h-7 object-cover rounded-full"
                        src={type === 'metamask' ? yellowMetaIcon : greenpillphantom}
                        alt="metamask"
                    />

                    <span>
                        Change <span className="font-semibold">Wallet</span>{' '}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default ChangeWalletWhite;
